import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ce7c35c8-38b3-46c7-87cc-f9c9273d3bf9/artifacts/tdjkcjsv_Comision%20Empresarial.png";

const QUICK_LINKS = [
  { href: "#quienes-somos", label: "Quiénes Somos" },
  { href: "#mision-vision", label: "Misión & Visión" },
  { href: "#valores", label: "Valores" },
  { href: "#servicios", label: "Servicios" },
  { href: "#contacto", label: "Contacto" },
];

const SERVICES = [
  "Capacitación Laboral Inclusiva",
  "Orientación Social y Desarrollo de Talento",
  "Investigación en Ciencias Sociales",
  "Consultoría en Expansión y Comercialización",
  "Auditoría de Procesos y Gestión de Riesgos",
];

const scrollTo = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#022140] text-white overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#055794]/30 blur-3xl"
      />
      <div className="container-page relative py-20 lg:py-24">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="Comisión Empresarial"
                className="h-14 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-[15px] text-white/70 leading-relaxed max-w-md">
              Impulsamos la competitividad, la innovación, el desarrollo
              tecnológico y la sustentabilidad de las empresas en México.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href="mailto:contacto@comisionempresarial.com"
                className="flex items-center gap-3 text-sm text-white/80 hover:text-[#72B3E4] transition-colors"
                data-testid="footer-email"
              >
                <Mail size={16} className="text-[#72B3E4]" />
                contacto@comisionempresarial.com
              </a>
              <a
                href="tel:+523326108716"
                className="flex items-center gap-3 text-sm text-white/80 hover:text-[#72B3E4] transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={16} className="text-[#72B3E4]" />
                33 2 610 8716
              </a>
              <div className="flex items-start gap-3 text-sm text-white/80">
                <MapPin size={16} className="text-[#72B3E4] mt-0.5 flex-shrink-0" />
                <span>
                  Calle Topografos 635, int. 3, Arcos de Guadalupe, C.P.
                  45037, Zapopan, Jalisco, México.
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="text-xs uppercase tracking-[0.25em] text-[#72B3E4] font-semibold mb-5">
              Navegación
            </p>
            <ul className="space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => scrollTo(e, l.href)}
                    className="text-[15px] text-white/80 hover:text-[#72B3E4] transition-colors"
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3 lg:col-start-10">
            <p className="text-xs uppercase tracking-[0.25em] text-[#72B3E4] font-semibold mb-5">
              Servicios
            </p>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li
                  key={s}
                  className="text-[15px] text-white/80 leading-snug"
                >
                  {s}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} Comisión Empresarial. Todos los
            derechos reservados.
          </p>
          <p className="text-xs uppercase tracking-[0.25em] text-white/50">
            comisionempresarial.com
          </p>
        </div>
      </div>

      {/* Giant brand watermark */}
      <div
        aria-hidden
        className="pointer-events-none select-none overflow-hidden w-full"
      >
        <p className="font-heading font-extrabold text-[8vw] sm:text-[8.5vw] leading-[0.95] text-white/[0.05] tracking-tight -mb-3 lg:-mb-5 text-center whitespace-nowrap">
          COMISIÓN EMPRESARIAL
        </p>
      </div>
    </footer>
  );
};
